export default __webpack_public_path__ + "static/media/rupees-icon-2.b305df52.jpg";